import React, { Component } from "react";
import {
	View,
	Text,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Alert,
	Platform,
	Image,
	Keyboard,
	AsyncStorage,
	Linking,
	ScrollView,
} from "react-native";

import { translate } from "react-i18next";

import Textfield from "components/Textfield";
import BackgroundImage from "components/BackgroundImage";
import Button from "components/Button";
import TextLink from "components/TextLink";
import StatusBar from "components/StatusBar";
import { login, autoLogin } from "utils/awsAuth";
import { push, reset } from "utils/navigation";
import { AppURL, AppVersion } from "utils/config";
import KeyboardView from "components/KeyboardView";
import * as x from "../../../styles/css";

class Login extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = false;

	constructor(props) {
		super(props);

		this.state = {
			error: { username: "", password: "" },
			username: "",
			password: "",
			loading: false,
		};

		this.goForgotPassword = this.goForgotPassword.bind(this);
		this.register = this.register.bind(this);
		this.loginUser = this.loginUser.bind(this);
		this.validate = this.validate.bind(this);
		this.privacyPolicy = this.privacyPolicy.bind(this);
	}

	componentWillMount() {
		if (Platform.OS === "web") {
			if (
				window.location.protocol === "https:" &&
				window.location.host !== "devg-coolbreeze-connect.s3.amazonaws.com"
			) {
				window.location.href = `https://${AppURL}/login`;
			}
		}
	}

	validate(text, field) {
		if (!text) {
			return `Please enter a ${field}`;
		}

		return "";
	}

	goForgotPassword() {
		push({ web: "/forgot", mobile: "ForgotPassword" }, this.props);
	}

	register() {
		push({ web: "/register", mobile: "Register" }, this.props);
	}

	privacyPolicy() {
		Linking.openURL("https://connect.coolbreeze.com.au/privacy-policy");
	}

	async loginUser() {
		Keyboard.dismiss();

		this.setState({
			loading: true,
			error: {
				username: "",
				password: "",
			},
		});

		if (
			this.validate(this.state.password).length > 0 ||
			this.validate(this.state.username).length > 0
		) {
			this.setState({
				error: {
					...this.state.error,
					password: this.validate(this.state.password, "password"),
					username: this.validate(this.state.username, "username"),
				},
				loading: false,
			});
			return;
		}

		try {
			const result = await login(
				this.state.username,
				this.state.password
			);
			this.setState({
				loading: false,
			});
			reset({ web: "/", mobile: "Home" }, this.props);
		} catch (error) {
			try {
				const result = await login(
					this.state.username.toLowerCase(),
					this.state.password
				);
				this.setState({
					loading: false,
				});
				reset({ web: "/", mobile: "Home" }, this.props);
			} catch (error) {
				this.setState({
					loading: false,
					error: {
						username: "Username and/or password not found",
						password: "Username and/or password not found",
					},
				});
			}
		}
	}

	render() {
		const { username, password, error } = this.state;
		const { t } = this.props;

		if (Platform.OS == "web") {
			return (
				<BackgroundImage
					resizeMode="cover"
					source={require("assets/bg.fw.jpg")}
					style={[x.app.backgroundImage]}
				>
					<KeyboardView style={[x.app.body]}>
						<View
							style={[
								x.justifyContent.center,
								x.alignItems.center,
								styles.appHeader,
							]}
						>
							<Image
								source={require("assets/connect.png")}
								style={[styles.imageWeb]}
							/>
						</View>
						<View
							style={[
								x.justifyContent.flexStart,
								x.alignItems.stretch,
							]}
						>
							<Textfield
								label={t("labels.login")}
								autoCapitalize={"none"}
								error={error.username}
								value={username}
								blurOnSubmit
								onChangeText={username =>
									this.setState({ username })
								}
								keyboardType="email-address"
							/>
							<Textfield
								label={t("labels.password")}
								error={error.password}
								value={password}
								onChangeText={password =>
									this.setState({ password })
								}
								blurOnSubmit
								secureTextEntry
								onSubmitEditing={this.loginUser}
								returnKeyType="done"
							/>
							<Button
								onPress={this.loginUser}
								title={t("labels.login")}
								color={x.colors.default}
								disabled={this.state.loading}
							/>
						</View>
						<View
							style={[
								x.d.flex,
								x.my.three,
								x.justifyContent.flexStart,
							]}
						>
							<TextLink
								onPress={this.goForgotPassword}
								title={t("labels.forgottenPassword")}
								color={x.colors.default}
								textAlign="center"
							/>
							<TextLink
								onPress={this.register}
								title={t("labels.dontHaveAccount")}
								color={x.colors.default}
								textAlign="center"
							/>
							<View style={[x.mt.auto]}>
								<TextLink
									onPress={this.privacyPolicy}
									title={t("labels.privacyPolicy")}
									color={x.colors.default}
									fontSize={14}
									textAlign="center"
								/>
							</View>
						</View>
						<View>
							<Text style={[styles.version]}>{AppVersion}</Text>
						</View>
					</KeyboardView>
				</BackgroundImage>
			);
		} else {
			return (
				<BackgroundImage
					resizeMode="cover"
					source={require("assets/bg.fw.jpg")}
					style={[x.app.backgroundImage]}
				>
					<KeyboardView
						style={[
							x.d.flex,
							x.app.body,
							x.justifyContent.center,
							x.alignItems.stretch,
						]}
					>
						<ScrollView
							alwaysBounceVertical={false}
							style={[x.d.flex]}
						>
							<View
								style={[
									x.d.flex,
									x.justifyContent.center,
									x.alignItems.center,
								]}
							>
								<Image
									source={require("assets/connect.png")}
									style={[styles.image]}
								/>
							</View>
							<View
								style={[
									x.d.flex,
									x.justifyContent.flexStart,
									x.alignItems.stretch,
								]}
							>
								<Textfield
									label={t("labels.login")}
									disabled={this.state.loading}
									autoCapitalize={"none"}
									error={error.username}
									value={username}
									blurOnSubmit
									onChangeText={username =>
										this.setState({ username })
									}
									keyboardType="email-address"
								/>
								<Textfield
									label={t("labels.password")}
									disabled={this.state.loading}
									error={error.password}
									value={password}
									onChangeText={password =>
										this.setState({ password })
									}
									blurOnSubmit
									secureTextEntry
									onSubmitEditing={this.loginUser}
									returnKeyType="done"
								/>
								<Button
									onPress={this.loginUser}
									title={t("labels.login")}
									color={x.colors.default}
									disabled={this.state.loading}
								/>
							</View>
							<View
								style={[
									x.d.flex,
									x.my.three,
									x.justifyContent.flexStart,
								]}
							>
								<TextLink
									onPress={this.goForgotPassword}
									title={t("labels.forgottenPassword")}
									color={x.colors.default}
									textAlign="center"
								/>
								<TextLink
									onPress={this.register}
									title={t("labels.dontHaveAccount")}
									color={x.colors.default}
									textAlign="center"
								/>
							</View>
							<View style={[x.d.flex, x.flexDirection.row]}>
								<Text
									style={[x.d.flex, x.my.one, styles.version]}
								>
									{AppVersion}
								</Text>
								<TextLink
									style={[x.d.flex]}
									onPress={this.privacyPolicy}
									title={t("labels.privacyPolicy")}
									color={x.colors.default}
									fontSize={14}
									textAlign="right"
								/>
							</View>
						</ScrollView>
					</KeyboardView>
				</BackgroundImage>
			);
		}
	}
}

const styles = StyleSheet.create({
	appHeader: {
		...(Platform.OS === "web" ? { height: 280 } : { height: 250 }),
	},
	version: {
		color: "gray",
		fontSize: 14,
	},
	image: {
		resizeMode: "contain",
		width: "100%",
		height: 200,
	},
	imageWeb: {
		flex: 0,
		resizeMode: "contain",
		height: "95%",
		width: "100%",
	},
});

export default translate()(Login);



// WEBPACK FOOTER //
// ./src/views/UserAuth/Login/index.js